import React from "react";
import { useTranslation } from "react-i18next";
import {Form, Input} from "antd";
import dayjs from "dayjs";

const {TextArea} = Input;

export const AdmissionDeleteForm = ({ formRef, formData, onValuesChange, executorData, edit }:any) => {

  const { t } = useTranslation('admissionNotes');

  return (
    <Form layout="vertical" autoComplete="off" onValuesChange={onValuesChange} form={formRef} name='delete_note_form'>

      {
        !edit ? <p> {formData.decline_reason} </p> :
          null
      }

      {!edit ? null :
        <Form.Item name='decline_reason' label={t("deleteNote.receiptTitleForm")}
                   rules={[{ required: true, message: t("revokeNote.error") }]}>
          <TextArea rows={4} placeholder={t("revokeNote.placeholder")}/>
        </Form.Item>
      }


      <p className='executor-caption'>{executorData && executorData.executor ? executorData.executor.fio : 'Исполнитель не найден'}</p>
      <p className='executor-subtitle'>{t("executorLabel")}</p>

      <p>{t("dateOfReceipt")} {dayjs().format('DD.MM.YYYY')}</p>

    </Form>
  )
}